/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern('Sync', 'metadata', ({ Api, servicename, resource }) => ({
  actions: {
    async get(_, { params }) {
      const { data, headers } = await Api.get(servicename, resource, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getData(_, { id, params }) {
      const { data, headers } = await Api.get(servicename, `${resource}/${id}/list-aggrouped`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getByCompany(_, { companyId, transactionId, params }) {
      const { data, headers } = await Api.get(servicename, `${resource}/company/${companyId}/${transactionId}/list`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getDataByCompany(_, { companyId, metadataId, params }) {
      const { data, headers } = await Api.get(servicename, `${resource}/company/${companyId}/${metadataId}/list-aggrouped`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async count(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/count`, { params });
      return data;
    },
    async find(_, { id, params }) {
      const { data } = await Api.get(servicename, `${resource}/${id}`, { params });
      return data;
    },
    async findByCompany(_, { companyId, id, params }) {
      const { data } = await Api.get(servicename, `${resource}/company/${companyId}/${id}`, { params });
      return data;
    },
    async delete(_, { id }) {
      await Api.delete(servicename, `${resource}/${id}`);
    },
    async create(_, { dataForm }) {
      const { data } = await Api.post(servicename, `${resource}`, dataForm);
      return data;
    },
    async update(_, { id, dataForm }) {
      const { data } = await Api.patch(servicename, `${resource}/${id}`, dataForm);
      return data;
    },
  },
}));
/* eslint-enable */
